import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import _ from 'lodash';
import Observer from 'react-intersection-observer';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Hidden from '@material-ui/core/Hidden';
import { Role } from '../../common/Constants';
import styles from '../../assets/jss/components/userSideBarStyle';
import {
    LogOutIcon,
    SurveyIcon,
    HomeIcon,
    LanguageIcon,
    ArrowDown,
    NextIcon,
} from '../Icons/Icon';

const a11yProps = (index) => ({
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
});

const useStyles = makeStyles(styles);

const UserSideBarCustomLayoutFirst = (props) => {
    const {
        customColorSidebar,
        listRoutes,
        eventInfo,
        isAuthorized,
        color,
        activeRoute,
        namePageCart,
        routerCheckTime,
        handleDrawerToggle,
        isAfterEnd30Day,
        isBeforeStart14Day,
        
        isAfterUsingEndXdays,
        isBeforeUsingStartXdays,
        params,
        routerActive,
        role,
        isUser,
        handleRedirectSurvey,
        handleLogOutSystem,
        options,
        classFixed,
        sidebarMobile,
        isOpenToggle,
        handleSelectLanguage,
        isGoogleTrans,
        language,
        isOpenTranslate,
        setIsOpenTranslate,
    } = props;
    const location = useLocation();
    const classes = useStyles(props);
    const cookies = new Cookies();
    const intl = useIntl();
    const [tabSelected, setTabSelected] = useState(0);
    const displayBackGroundImage = location.pathname.indexOf('/home') >= 0;
    const showGoogleTran = sessionStorage.getItem('objLang');
    const sidebarRef = useRef();
    const dropdownRef = useRef();
    const [cssLang, setCssLang] = useState({ right: '58px' });

    useEffect(() => {
        if (displayBackGroundImage) {
            setTabSelected(0);
        } else {
            setTabSelected(+routerActive);
        }
    }, [routerActive]);

    useEffect(() => {
        window.addEventListener('resize', () => setIsOpenTranslate(false));
        return () => {
            window.removeEventListener('resize', () => setIsOpenTranslate(false));
        };
    }, []);

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target) && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpenTranslate(false);
            }
        }
        // Bind the event listener
        if (window.innerWidth > 960) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
        // Unbind the event listener on clean up
            if (window.innerWidth > 960) document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [sidebarRef, dropdownRef]);

    const handleOnChange = (event, value) => {
        setTabSelected(value);
        cookies.set('tabSelect', value, { path: '/' });
    };

    const handleChangeLanguage = (nameLang, textLang, changeLang, isUpdate) => {
        setIsOpenTranslate(false);
        handleSelectLanguage(nameLang, textLang, changeLang, isUpdate);
    };
    const handleShowLang = () => {
        setIsOpenTranslate(!isOpenTranslate);
        const left = document.getElementById('focusDiv').offsetLeft + 78;
        const checkShowClass = document.getElementById('tabsId').firstChild.className.includes('disabled')
            || document.getElementById('tabsId').firstChild.className.includes('MuiTabs-scrollButtons');
        setCssLang(checkShowClass ? { right: '58px' } : { left: `${left}px` });
    };

    const sidebarWeb = () => (
        <Hidden smDown implementation="css">
            <Observer {...options} />
            <div className={classNames(classFixed && classes.drawerPaperCustomLayout, classes.backgroundVisitorCustom)}>
                <div className={classes.sidebarCustomLayout}>
                    <div className={isAuthorized ? classes.sideCustomLayoutLeftWithLogin : classes.sideCustomLayoutLeft}>
                        <Tab
                            label={(
                                <NavLink
                                    exact
                                    className={classes.itemLinkHomeCustomLayout}
                                    to={`/${params.shortName}/home`}
                                >
                                    <HomeIcon color={customColorSidebar?.sidebar_icon?.other || '#fff'} />
                                </NavLink>
                            )}
                            classes={{ root: classes.rootTabHome }}
                        />
                        <Tabs
                            classes={{ root: classes.root }}
                            value={tabSelected}
                            onChange={handleOnChange}
                            position="static"
                            color="default"
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example"
                            id="tabsId"
                        >
                            {
                                listRoutes.map((prop, index) => {
                                    if (prop.path === '/exhibitor-posters' && (!isAuthorized || isAfterUsingEndXdays)) {
                                        return '';
                                    }
                                    if ((prop.path === '/seminar_registered' || prop.path === '/seminars') && (!isAuthorized)) {
                                        return '';
                                    }
                                    if (routerCheckTime.includes(prop.path) && isBeforeUsingStartXdays) {
                                        return '';
                                    }
                                    const listItemClasses = classNames({
                                        [` ${classes[color]}`]: activeRoute(`${prop.param}${prop.path}`),
                                    });
                                    return (
                                        <Tab
                                            label={(
                                                <NavLink
                                                    to={`/${params.shortName}${prop.path}`}
                                                    text={prop?.isCheckCount ? namePageCart(prop.name) : prop.name}
                                                    className={classes.itemCustomLayout}
                                                    activeClassName="active"
                                                    exact
                                                    isActive={prop.isActiveFunc}
                                                    key={prop.path}
                                                >
                                                    <div className={classes.itemLinkCustomLayout + listItemClasses}>
                                                        <div>
                                                            <prop.icon
                                                                color={activeRoute(`${prop.param}${prop.path}`)
                                                                    ? (customColorSidebar?.sidebar_icon?.selected || '#fff')
                                                                    : customColorSidebar?.sidebar_icon?.other || '#fff'}
                                                            />
                                                            <div className={classNames(activeRoute(`${prop.param}${prop.path}`)
                                                                ? classes.visitorTextLogoutLayoutCustomActive
                                                                : classes.visitorTextLogoutLayoutCustom)}
                                                            >
                                                                {prop?.isCheckCount
                                                                    ? namePageCart(eventInfo?.settings_texts_sidebar_viewer?.field_name?.[prop.customName] || prop.name)
                                                                    : (eventInfo?.settings_texts_sidebar_viewer?.field_name?.[prop.customName] || prop.name)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </NavLink>
                                            )}
                                            {...a11yProps(index)}
                                            aria-selected={index}
                                            classes={{ root: classes.rootTab }}
                                        />
                                    );
                                })
                            }
                            {!(!isAuthorized || !isUser || (_.toNumber(role) === Role.viewer && !eventInfo.survey_link_viewer)) && (
                                <Tab
                                    label={(
                                        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                                        <div
                                            className={classes.itemLinkCustomLayoutSurvey}
                                            onClick={() => handleRedirectSurvey()}
                                        >
                                            <SurveyIcon
                                                color={customColorSidebar?.sidebar_icon?.other || '#fff'}
                                            />
                                            <div className={classes.visitorTextLogoutLayoutCustom}>
                                                {eventInfo?.settings_texts_sidebar_viewer?.field_name?.survey || intl.formatMessage({ id: 'userRouters.survey' })}
                                            </div>
                                        </div>
                                    )}
                                    classes={{ root: classes.rootTabSurvey }}
                                />
                            )}
                            {!_.isEmpty(eventInfo.languages) && eventInfo?.done_language_config && (
                                <Tab
                                    ref={sidebarRef}
                                    label={(
                                        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                                        <div
                                            className={classes.itemLinkCustomLayoutSurvey}
                                            onClick={handleShowLang}
                                        >
                                            <LanguageIcon
                                                color={customColorSidebar?.sidebar_icon?.other || '#fff'}
                                            />
                                            <div className={classes.visitorTextLogoutLayoutCustom}>
                                                {language}
                                                {isOpenTranslate
                                                    ? <ArrowDown className={classes.visitorText} />
                                                    : <NextIcon className={classes.visitorText} />}
                                            </div>
                                        </div>
                                    )}
                                    classes={{ root: classes.rootTabSurvey }}
                                    id="focusDiv"
                                />
                            )}
                        </Tabs>

                        <ul
                            className={isOpenTranslate ? classes.translateOpenCustom : classes.translateClose}
                            ref={dropdownRef}
                            style={cssLang}
                        >
                            <ListItem button onClick={() => handleChangeLanguage('ja', '日本語', true, true)} className={classes.mainItemTranslate}>
                                <ListItemText
                                    primary="日本語"
                                    className={classes.visitorText}
                                    disableTypography
                                />
                            </ListItem>
                            <ListItem button onClick={() => handleChangeLanguage('en', 'English', true, true)} className={classes.mainItemTranslate}>
                                <ListItemText
                                    // eslint-disable-next-line no-nested-ternary
                                    primary={!showGoogleTran ? 'English' : (isGoogleTrans ? 'English' : 'English/Other Language')}
                                    className={classes.visitorTextOther}
                                />
                            </ListItem>
                            {showGoogleTran && <ListItem id="google_translate_element" className={classes.test} />}
                        </ul>
                    </div>
                    {isAuthorized && isUser && Number(role) !== Role.admin && (
                        <div>
                            <Tab
                                label={(
                                    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                                    <div
                                        className={`${classes.itemLinkCustomLayoutSurvey} ${classes.orange}`}
                                        onClick={() => handleLogOutSystem()}
                                    >
                                        <LogOutIcon
                                            color={customColorSidebar?.sidebar_icon?.other || '#fff'}
                                        />
                                        <div className={classes.visitorTextLogoutLayoutCustom}>
                                            {eventInfo?.settings_texts_sidebar_viewer?.field_name?.logout || <FormattedMessage id="logout" />}
                                        </div>
                                    </div>
                                )}
                                classes={{ root: classes.rootTabSurvey }}
                            />
                        </div>
                    )}
                </div>
            </div>
        </Hidden>
    );

    const sidebarMobileCustom = () => (
        <Hidden mdUp implementation="css">
            {isOpenToggle && (
                <div className={classes.drawerPaperMobileCustomLayout}>
                    {sidebarMobile}
                    <p className={classes.opacityMobile} onClick={() => handleDrawerToggle()} />
                </div>
            )}
        </Hidden>
    );

    return (
        <>
            {sidebarMobileCustom()}
            {sidebarWeb()}
        </>
    );
};

UserSideBarCustomLayoutFirst.defaultProps = {
    color: 'blue',
    isAuthorized: false,
    isUser: false,
    listRoutes: {},
    eventInfo: {},
    customColorSidebar: {},
    activeRoute: () => {},
    handleDrawerToggle: () => {},
    namePageCart: () => {},
    routerCheckTime: [],
    params: {},
    isAfterEnd30Day: false,
    isBeforeStart14Day: false,
    
    isAfterUsingEndXdays:false,
    isBeforeUsingStartXdays: false,
    
    routerActive: 0,
    handleRedirectSurvey: () => {},
    handleLogOutSystem: () => {},
    handleBackHomePage: () => {},
    options: {},
    classFixed: '',
    sidebarMobile: undefined,
    isOpenToggle: false,
    handleSelectLanguage: () => {},
    isGoogleTrans: false,
    language: '',
    isOpenTranslate: false,
    setIsOpenTranslate: () => {},
};

UserSideBarCustomLayoutFirst.propTypes = {
    color: PropTypes.string,
    listRoutes: PropTypes.oneOfType([() => null, PropTypes.array]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    isAuthorized: PropTypes.bool,
    isUser: PropTypes.bool,
    customColorSidebar: PropTypes.oneOfType([() => null, PropTypes.object]),
    activeRoute: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
    namePageCart: PropTypes.func,
    routerCheckTime: PropTypes.oneOfType([() => null, PropTypes.array]),
    params: PropTypes.oneOfType([() => null, PropTypes.object]),
    isAfterEnd30Day: PropTypes.bool,
    isBeforeStart14Day: PropTypes.bool,

    isAfterUsingEndXdays:PropTypes.bool,
    isBeforeUsingStartXdays: PropTypes.bool,

    routerActive: PropTypes.number,
    role: PropTypes.number.isRequired,
    handleRedirectSurvey: PropTypes.func,
    handleLogOutSystem: PropTypes.func,
    handleBackHomePage: PropTypes.func,
    options: PropTypes.oneOfType([() => null, PropTypes.object]),
    classFixed: PropTypes.string,
    sidebarMobile: PropTypes.node,
    isOpenToggle: PropTypes.bool,
    handleSelectLanguage: PropTypes.func,
    isGoogleTrans: PropTypes.bool,
    language: PropTypes.string,
    isOpenTranslate: PropTypes.bool,
    setIsOpenTranslate: PropTypes.func,
};

export default UserSideBarCustomLayoutFirst;
